import { Component, EventEmitter, Input, Output, HostBinding } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { AppConstants } from '@fcom/booking/app-constants';

@Component({
  selector: 'fin-booking-summary-section',
  styleUrls: ['./booking-summary-section.component.scss'],
  templateUrl: './booking-summary-section.component.html',
  standalone: false,
})
export class BookingSummarySectionComponent {
  public readonly C: typeof AppConstants = AppConstants;

  @Input()
  title: string;
  @Input()
  icon: SvgLibraryIcon;
  @Input()
  isChangeButton = true;
  @Input()
  editText: string;
  @Input()
  skipEditAlign = false;
  @Input()
  isContent = true;
  @Input()
  titleClass = 'font-heading-4';
  @Input()
  innerClass = 'pr-large-t';
  @Input()
  innerIconClass = 'nordic-blue-900-text';
  @Input()
  isDisabled = false;
  @Input()
  trackingContext: string;

  @HostBinding('class.block') defaultClass = true;
  @HostBinding('class.ps-medium-b')
  get padding() {
    return this.isChangeButton;
  }
  @Output()
  edit: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}
}
